/* 顺风车代客下单 */
<template>
  <div id="orderFormHitchRide">

    <div class="ofhr-header" @click="$router.back()">
      <i class="el-icon-arrow-left"></i> 返回
    </div>

    <div class="ofhr-card">
      <div class="ofhr-title">
        <div class="title-left">
          <i class="el-icon-location title-icon"></i>
          <div>
            <span class="title-text">顺风车代客下单</span>
            <span class="title-sub">管理员代乘客发布顺风车订单，发布后司机可抢单</span>
          </div>
        </div>
        <el-tag size="small" type="warning">管理员操作</el-tag>
      </div>
      <div class="notice-bar">
        <i class="el-icon-info-solid"></i>
        顺风车不支持预约班次，订单发布后司机实时抢单，平台可在“指派列表”中查看和拆单
      </div>
    </div>

    <!-- 第一步：填写行程信息 -->
    <div class="ofhr-card" v-show="step === 1">
      <div class="ofhr-step-title"><span class="step-badge">1</span> 填写行程信息</div>
      <el-form :model="form" :rules="rules" ref="tripForm" label-width="80px" label-position="left">

        <!-- 出发地搜索 -->
        <el-form-item label="出发地" prop="startPointName">
          <div v-if="!form.startPointName" class="addr-search-box">
            <choose-address
              :value.sync="startKeyword"
              placeholder="搜索出发地（地名/地址/POI）"
              @clickRowFn="onStartSelected"
              @clearFn="onStartClear"
            />
          </div>
          <div v-else class="selected-addr-card">
            <div class="selected-addr-left">
              <i class="el-icon-location addr-dot start-dot"></i>
              <div class="selected-addr-texts">
                <div class="selected-addr-name">{{ form.startPointName }}</div>
                <div class="selected-addr-sub">{{ form.startPointAddress || '—' }}</div>
                <div class="selected-addr-coord">{{ form.startPointLng }}, {{ form.startPointLat }}</div>
              </div>
            </div>
            <el-button type="text" size="mini" @click="onStartClear"><i class="el-icon-refresh"></i> 重选</el-button>
          </div>
        </el-form-item>

        <!-- 目的地搜索 -->
        <el-form-item label="目的地" prop="endPointName">
          <div v-if="!form.endPointName" class="addr-search-box">
            <choose-address
              :value.sync="endKeyword"
              placeholder="搜索目的地（地名/地址/POI）"
              @clickRowFn="onEndSelected"
              @clearFn="onEndClear"
            />
          </div>
          <div v-else class="selected-addr-card">
            <div class="selected-addr-left">
              <i class="el-icon-location-information addr-dot end-dot"></i>
              <div class="selected-addr-texts">
                <div class="selected-addr-name">{{ form.endPointName }}</div>
                <div class="selected-addr-sub">{{ form.endPointAddress || '—' }}</div>
                <div class="selected-addr-coord">{{ form.endPointLng }}, {{ form.endPointLat }}</div>
              </div>
            </div>
            <el-button type="text" size="mini" @click="onEndClear"><i class="el-icon-refresh"></i> 重选</el-button>
          </div>
        </el-form-item>

        <!-- 出发时间 -->
        <el-form-item label="出发时间" prop="departureTime">
          <div class="quick-date-btns">
            <el-button
              v-for="(q, i) in quickDates" :key="i" size="mini"
              :type="quickDateIndex === i ? 'primary' : 'default'"
              @click="applyQuickDate(i)"
            >{{ q.label }}</el-button>
            <span class="quick-date-hint">默认 08:00 ~ 20:00，可自定义</span>
          </div>
          <el-date-picker
            v-model="form.departureTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="最早出发时间"
            end-placeholder="最晚出发时间"
            :picker-options="pickerOptions"
            value-format="timestamp"
            style="width:100%;margin-top:8px"
            @change="onDepartureChange"
          />
        </el-form-item>

        <!-- 乘客人数 -->
        <el-form-item label="乘客人数" prop="passengerNum">
          <el-radio-group v-model="form.passengerNum" @change="resetEstimate">
            <el-radio-button v-for="i in 5" :label="i" :key="i">{{ i }}人</el-radio-button>
          </el-radio-group>
          <span class="field-hint">顺风车最多5人</span>
        </el-form-item>

        <!-- 拼车类型 -->
        <el-form-item label="拼车类型" prop="poolType">
          <div class="pool-type-group">
            <div
              class="pool-type-card"
              :class="{ active: form.poolType === 1 }"
              @click="form.poolType = 1; resetEstimate()"
            >
              <div class="pt-title">独享</div>
              <div class="pt-desc">整车专属，不与他人拼乘</div>
            </div>
            <div
              class="pool-type-card"
              :class="{ active: form.poolType === 2 }"
              @click="form.poolType = 2; resetEstimate()"
            >
              <div class="pt-title">拼车</div>
              <div class="pt-desc">顺路同行，价格更优惠</div>
            </div>
          </div>
        </el-form-item>

        <!-- 高速费 -->
        <el-form-item label="高速费">
          <el-radio-group v-model="form.bearHighwayFeeType">
            <el-radio :label="1">乘客承担</el-radio>
            <el-radio :label="2">车主承担</el-radio>
            <el-radio :label="3">双方分摊</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>

      <!-- 预估价结果 -->
      <transition name="el-fade-in-linear">
        <div v-if="estimateResult" class="estimate-result">
          <div class="estimate-header">
            <i class="el-icon-price-tag"></i> 预估价格
            <span class="estimate-valid">（预估标识10分钟内有效，请尽快完成下单）</span>
          </div>
          <el-row :gutter="20" style="margin-top:12px">
            <el-col :span="8">
              <div class="estimate-item" :class="{ active: form.poolType === 1 }">
                <div class="estimate-label">独享价</div>
                <div class="estimate-value">¥{{ (estimateResult.estimatePrice / 100).toFixed(2) }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="estimate-item" :class="{ active: form.poolType === 2 }">
                <div class="estimate-label">拼车成功价</div>
                <div class="estimate-value">¥{{ (estimateResult.poolSucPrice / 100).toFixed(2) }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="estimate-item">
                <div class="estimate-label">预计行驶距离</div>
                <div class="estimate-value">{{ (estimateResult.distance / 1000).toFixed(1) }}<small>km</small></div>
              </div>
            </el-col>
          </el-row>
        </div>
      </transition>

      <div class="ofhr-footer">
        <el-button @click="$router.back()">取消</el-button>
        <el-button
          type="info"
          :loading="estimateLoading"
          @click="getEstimatePrice"
          :disabled="!form.startPointName || !form.endPointName || !form.departureTime"
        ><i class="el-icon-refresh"></i> 获取预估价</el-button>
        <el-button type="primary" :disabled="!estimateResult" @click="nextStep">
          下一步 <i class="el-icon-arrow-right"></i>
        </el-button>
      </div>
    </div>

    <!-- 第二步：乘客信息与发单确认 -->
    <div class="ofhr-card" v-show="step === 2">
      <div class="ofhr-step-title"><span class="step-badge">2</span> 乘客信息 &amp; 确认发单</div>

      <!-- 行程摘要 -->
      <div class="trip-summary">
        <div class="route-line-wrap">
          <div class="route-node">
            <span class="route-dot start-dot"></span>
            <div class="route-node-info">
              <div class="route-node-name">{{ form.startPointName }}</div>
              <div class="route-node-addr">{{ form.startPointAddress }}</div>
            </div>
          </div>
          <div class="route-connector"></div>
          <div class="route-node">
            <span class="route-dot end-dot"></span>
            <div class="route-node-info">
              <div class="route-node-name">{{ form.endPointName }}</div>
              <div class="route-node-addr">{{ form.endPointAddress }}</div>
            </div>
          </div>
        </div>
        <div class="trip-meta-row">
          <div class="trip-meta-item">
            <div class="trip-meta-label">出发时间</div>
            <div class="trip-meta-val">
              {{ form.departureTime ? $utils.timeFn(form.departureTime[0], 'MM/DD HH:mm') : '-' }}
              ~ {{ form.departureTime ? $utils.timeFn(form.departureTime[1], 'HH:mm') : '' }}
            </div>
          </div>
          <div class="trip-meta-item">
            <div class="trip-meta-label">{{ form.poolType === 1 ? '独享' : '拼车' }} · {{ form.passengerNum }}人</div>
            <div class="trip-meta-val price-text" v-if="estimateResult">
              ¥{{ form.poolType === 1 ? (estimateResult.estimatePrice / 100).toFixed(2) : (estimateResult.poolSucPrice / 100).toFixed(2) }}
            </div>
          </div>
          <div class="trip-meta-item" v-if="estimateResult">
            <div class="trip-meta-label">预计距离</div>
            <div class="trip-meta-val">{{ (estimateResult.distance / 1000).toFixed(1) }} km</div>
          </div>
        </div>
      </div>

      <!-- 乘客信息 -->
      <div class="section-label" style="margin-top:20px">乘客信息</div>
      <el-form :model="passengerForm" :rules="passengerRules" ref="passengerFormRef" label-width="90px" label-position="left">

        <el-form-item label="乘客手机号" prop="passengerPhone">
          <el-input
            v-model="passengerForm.passengerPhone"
            placeholder="输入乘客完整手机号（11位）"
            maxlength="11"
            clearable
            @input="onPhoneInput"
          >
            <el-button slot="append" :loading="customerSearchLoading" icon="el-icon-search" @click="searchCustomer">查找系统乘客</el-button>
          </el-input>
          <div class="field-sub-hint">后端将自动提取后4位生成虚拟号，司机通过虚拟号联系乘客</div>
        </el-form-item>

        <!-- 搜索到的乘客列表 -->
        <div v-if="customerList.length > 0" class="customer-pick-list">
          <div class="customer-pick-title">找到以下系统注册乘客，点击选择关联（可选）：</div>
          <div
            v-for="c in customerList" :key="c.id"
            class="customer-pick-item"
            :class="{ selected: passengerForm.customerId === c.id }"
            @click="selectCustomer(c)"
          >
            <div class="cp-avatar">{{ ((c.realName || c.name || c.phone || '?')[0]).toUpperCase() }}</div>
            <div class="cp-info">
              <div class="cp-name">{{ c.realName || c.name || '未实名' }}</div>
              <div class="cp-phone">{{ c.phone }}</div>
              <el-tag v-if="c.isRealName === 1" size="mini" type="success" style="margin-left:4px">已实名</el-tag>
            </div>
            <i v-if="passengerForm.customerId === c.id" class="el-icon-check cp-check"></i>
          </div>
        </div>

        <div v-if="customerSearched && customerList.length === 0" class="customer-not-found">
          <i class="el-icon-info"></i>
          系统内未找到该手机号的注册乘客，将以匿名方式发单（后端自动生成乘客标识）
        </div>

      </el-form>

      <div class="ofhr-footer">
        <el-button @click="step = 1"><i class="el-icon-arrow-left"></i> 上一步</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitOrder">确认发单</el-button>
      </div>
    </div>

    <!-- 第三步：发单成功 -->
    <div class="ofhr-card success-card" v-if="step === 3">
      <i class="el-icon-circle-check success-icon"></i>
      <div class="success-title">发单成功</div>
      <div class="success-sub">订单已发布，等待司机抢单</div>
      <div class="success-info" v-if="successOrderNo">
        <span>订单号：</span><strong>{{ successOrderNo }}</strong>
      </div>
      <div class="ofhr-footer" style="justify-content:center">
        <el-button type="primary" @click="resetAll">继续发单</el-button>
        <el-button @click="$router.push('/hitchRideOrderDispatch')">查看指派列表</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import chooseAddress from '@/components/chooseAddress.vue';

export default {
  name: 'orderFormHitchRide',
  components: { chooseAddress },
  data() {
    const today = new Date();
    const tomorrow = new Date(); tomorrow.setDate(today.getDate() + 1);
    const dayAfter = new Date(); dayAfter.setDate(today.getDate() + 2);
    return {
      step: 1,
      estimateLoading: false,
      submitLoading: false,
      customerSearchLoading: false,
      customerSearched: false,
      estimateResult: null,
      successOrderNo: '',
      customerList: [],
      quickDateIndex: null,
      startKeyword: '',
      endKeyword: '',
      quickDates: [
        { label: '今天', date: today },
        { label: '明天', date: tomorrow },
        { label: '后天', date: dayAfter },
      ],
      form: {
        startPointName: '', startPointAddress: '',
        startPointLng: null, startPointLat: null, startCityCode: '',
        endPointName: '', endPointAddress: '',
        endPointLng: null, endPointLat: null,
        departureTime: null, passengerNum: 1, poolType: 1, bearHighwayFeeType: 1,
      },
      passengerForm: {
        passengerPhone: '',
        customerId: null,
      },
      rules: {
        startPointName: [{ required: true, message: '请搜索并选择出发地', trigger: 'change' }],
        endPointName: [{ required: true, message: '请搜索并选择目的地', trigger: 'change' }],
        departureTime: [{ required: true, message: '请选择出发时间范围', trigger: 'change' }],
        passengerNum: [{ required: true, message: '请选择乘客人数', trigger: 'change' }],
        poolType: [{ required: true, message: '请选择拼车类型', trigger: 'change' }],
      },
      passengerRules: {
        passengerPhone: [
          { required: true, message: '请填写乘客手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请填写正确的11位手机号', trigger: 'blur' },
        ],
      },
      pickerOptions: {
        disabledDate(time) { return time.getTime() < Date.now() - 8.64e7; },
      },
    };
  },
  methods: {
    /* === 地址选择 === */
    onStartSelected(item) {
      this.form.startPointName = item.name;
      this.form.startPointAddress = typeof item.address === 'string' ? item.address : (item.district || '');
      this.form.startPointLng = item.location ? item.location.lng : null;
      this.form.startPointLat = item.location ? item.location.lat : null;
      this.form.startCityCode = item.citycode || item.adcode || '';
      this.startKeyword = item.name;
      this.resetEstimate();
      this.$refs.tripForm && this.$refs.tripForm.validateField('startPointName');
    },
    onStartClear() {
      Object.assign(this.form, { startPointName: '', startPointAddress: '', startPointLng: null, startPointLat: null, startCityCode: '' });
      this.startKeyword = '';
      this.resetEstimate();
    },
    onEndSelected(item) {
      this.form.endPointName = item.name;
      this.form.endPointAddress = typeof item.address === 'string' ? item.address : (item.district || '');
      this.form.endPointLng = item.location ? item.location.lng : null;
      this.form.endPointLat = item.location ? item.location.lat : null;
      this.endKeyword = item.name;
      this.resetEstimate();
      this.$refs.tripForm && this.$refs.tripForm.validateField('endPointName');
    },
    onEndClear() {
      Object.assign(this.form, { endPointName: '', endPointAddress: '', endPointLng: null, endPointLat: null });
      this.endKeyword = '';
      this.resetEstimate();
    },

    /* === 快捷日期 === */
    applyQuickDate(index) {
      this.quickDateIndex = index;
      const d = this.quickDates[index].date;
      const start = new Date(d); start.setHours(8, 0, 0, 0);
      const end = new Date(d); end.setHours(20, 0, 0, 0);
      this.form.departureTime = [start.getTime(), end.getTime()];
      this.resetEstimate();
      this.$refs.tripForm && this.$refs.tripForm.validateField('departureTime');
    },
    onDepartureChange() { this.quickDateIndex = null; this.resetEstimate(); },

    /* === 预估价 === */
    resetEstimate() { this.estimateResult = null; },

    async getEstimatePrice() {
      this.$refs.tripForm.validate(async (valid) => {
        if (!valid) return;
        if (!this.form.startPointLng) { this.$message.warning('请重新搜索并选择出发地'); return; }
        if (!this.form.endPointLng) { this.$message.warning('请重新搜索并选择目的地'); return; }
        this.estimateLoading = true;
        try {
          const res = await this.$axios.get('/api/v1/manage/order/hitchRide/platform/estimatePrice', {
            startPointLng: this.form.startPointLng, startPointLat: this.form.startPointLat,
            startPointName: this.form.startPointName,
            endPointLng: this.form.endPointLng, endPointLat: this.form.endPointLat,
            endPointName: this.form.endPointName,
            earliestDepartureTime: Math.floor(this.form.departureTime[0] / 1000),
            latestDepartureTime: Math.floor(this.form.departureTime[1] / 1000),
            passengerNum: this.form.passengerNum,
            cityId: this.form.startCityCode || '',
          });
          if (res && res.result === 0 && res.data) {
            this.estimateResult = res.data;
            this.$message.success('预估价获取成功');
          } else {
            this.$message.error((res && res.message) || '预估价获取失败，请检查地址是否有效');
          }
        } finally { this.estimateLoading = false; }
      });
    },

    nextStep() {
      if (!this.estimateResult) { this.$message.warning('请先获取预估价'); return; }
      this.step = 2;
    },

    /* === 乘客搜索 === */
    onPhoneInput() { this.customerSearched = false; this.customerList = []; this.passengerForm.customerId = null; },

    async searchCustomer() {
      const phone = this.passengerForm.passengerPhone;
      if (!phone || !/^1\d{10}$/.test(phone)) { this.$message.warning('请先填写正确的11位手机号'); return; }
      this.customerSearchLoading = true;
      this.customerSearched = false;
      this.customerList = [];
      try {
        const res = await this.$axios.get('/api/v1/manage/customer', { phone, pageNum: 1, pageSize: 5 });
        if (res && res.code === 1 && res.data && res.data.length > 0) {
          this.customerList = res.data;
        }
      } finally { this.customerSearched = true; this.customerSearchLoading = false; }
    },

    selectCustomer(c) { this.passengerForm.customerId = c.id; },

    /* === 提交发单 === */
    async submitOrder() {
      this.$refs.passengerFormRef.validate(async (valid) => {
        if (!valid) return;
        this.submitLoading = true;
        try {
          const res = await this.$axios.post('/api/v1/manage/order/hitchRide/platform/create', {
            cityId: this.form.startCityCode || '',
            startPointAddress: this.form.startPointAddress,
            startPointLng: this.form.startPointLng, startPointLat: this.form.startPointLat,
            startPointName: this.form.startPointName,
            endPointAddress: this.form.endPointAddress,
            endPointLng: this.form.endPointLng, endPointLat: this.form.endPointLat,
            endPointName: this.form.endPointName,
            earliestDepartureTime: Math.floor(this.form.departureTime[0] / 1000),
            latestDepartureTime: Math.floor(this.form.departureTime[1] / 1000),
            passengerNum: this.form.passengerNum, poolType: this.form.poolType,
            bearHighwayFeeType: this.form.bearHighwayFeeType,
            passengerPhone: this.passengerForm.passengerPhone,
            customerId: this.passengerForm.customerId || null,
            estimateId: this.estimateResult.estimateId,
            amount: this.form.poolType === 1 ? this.estimateResult.estimatePrice : this.estimateResult.poolSucPrice,
          });
          if (res && res.result === 0 && res.data) {
            this.successOrderNo = res.data.orderNo || res.data.partnerOrderId || String(res.data) || '';
            this.step = 3;
          } else {
            this.$message.error((res && res.message) || '发单失败，请重试');
          }
        } finally { this.submitLoading = false; }
      });
    },

    /* === 重置 === */
    resetAll() {
      this.step = 1; this.estimateResult = null; this.successOrderNo = '';
      this.startKeyword = ''; this.endKeyword = ''; this.customerList = [];
      this.customerSearched = false; this.quickDateIndex = null;
      this.form = {
        startPointName: '', startPointAddress: '', startPointLng: null, startPointLat: null, startCityCode: '',
        endPointName: '', endPointAddress: '', endPointLng: null, endPointLat: null,
        departureTime: null, passengerNum: 1, poolType: 1, bearHighwayFeeType: 1,
      };
      this.passengerForm = { passengerPhone: '', customerId: null };
      this.$nextTick(() => { this.$refs.tripForm && this.$refs.tripForm.clearValidate(); });
    },
  },
};
</script>

<style lang="less">
#orderFormHitchRide {
  min-height: calc(100% - 48px);
  padding-bottom: 40px;
  box-sizing: border-box;
  background: #f5f6fa;
  display: flex;
  flex-flow: column;
  align-items: center;
  overflow-y: auto;

  .ofhr-header {
    width: 1100px;
    margin-top: 16px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    color: #606266;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 12px 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
    box-sizing: border-box;

    i { font-size: 16px; }

    &:hover {
      color: #409EFF;
      background: #ecf5ff;
    }
  }

  .ofhr-card {
    width: 1100px;
    margin-top: 16px;
    padding: 24px 28px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  }

  .ofhr-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
    padding-bottom: 14px;
    border-bottom: 1px solid #f0f2f5;

    .title-left {
      display: flex;
      align-items: center;
      gap: 12px;

      .title-icon {
        font-size: 24px;
        color: #67C23A;
      }

      .title-text {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        display: block;
      }

      .title-sub {
        font-size: 13px;
        color: #909399;
        display: block;
        margin-top: 2px;
      }
    }
  }

  .notice-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: #f0f9eb;
    border-radius: 6px;
    border: 1px solid #b3e19d;
    color: #67C23A;
    font-size: 13px;
  }

  .ofhr-step-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    .step-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background: #409eff;
      color: #fff;
      font-size: 13px;
      font-weight: 700;
    }
  }

  /* 地址搜索框 */
  .addr-search-box {
    width: 100%;
    #chooseAddress {
      width: 100%;
      display: block;
      .area-input { width: 100%; }
      .map-show { width: 100%; left: 0; min-width: 400px; }
      .close-btn { right: 10px; }
    }
  }

  /* 已选地址卡片 */
  .selected-addr-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    background: #f0f9f0;
    border: 1px solid #b7e5b7;
    border-radius: 8px;

    .selected-addr-left {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      flex: 1;
    }

    .addr-dot {
      font-size: 20px;
      margin-top: 2px;
      flex-shrink: 0;
      &.start-dot { color: #409eff; }
      &.end-dot { color: #f56c6c; }
    }

    .selected-addr-texts {
      .selected-addr-name { font-size: 15px; font-weight: 600; color: #303133; }
      .selected-addr-sub { font-size: 12px; color: #909399; margin-top: 2px; }
      .selected-addr-coord { font-size: 11px; color: #c0c4cc; margin-top: 2px; }
    }
  }

  /* 快捷日期 */
  .quick-date-btns {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    .quick-date-hint { font-size: 12px; color: #c0c4cc; }
  }

  /* 字段提示 */
  .field-hint {
    margin-left: 10px;
    font-size: 12px;
    color: #909399;
  }

  .field-sub-hint {
    font-size: 12px;
    color: #c0c4cc;
    margin-top: 4px;
    line-height: 1.5;
  }

  /* 拼车类型卡片 */
  .pool-type-group {
    display: flex;
    gap: 16px;
    .pool-type-card {
      flex: 1;
      padding: 14px 16px;
      border: 2px solid #ebeef5;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.2s;
      &:hover { border-color: #a0cfff; background: #f0f7ff; }
      &.active { border-color: #409eff; background: #ecf5ff; }
      .pt-title { font-size: 15px; font-weight: 700; color: #303133; }
      .pt-desc { font-size: 12px; color: #909399; margin-top: 4px; }
    }
  }

  /* 预估价 */
  .estimate-result {
    margin-top: 20px;
    padding: 16px 20px;
    background: #f0f7ff;
    border-radius: 10px;
    border: 1px solid #d0e8ff;

    .estimate-header {
      font-size: 14px;
      font-weight: 600;
      color: #409eff;
      .estimate-valid { font-size: 12px; color: #c0c4cc; font-weight: normal; margin-left: 8px; }
    }

    .estimate-item {
      text-align: center;
      padding: 10px;
      border-radius: 8px;
      border: 2px solid transparent;
      transition: all 0.2s;
      &.active { border-color: #409eff; background: #fff; }
      .estimate-label { font-size: 12px; color: #909399; }
      .estimate-value { font-size: 22px; font-weight: 700; color: #303133; margin-top: 4px;
        small { font-size: 12px; font-weight: normal; margin-left: 2px; }
      }
    }
  }

  /* 行程摘要（Step2） */
  .trip-summary {
    background: #f8f9fc;
    border-radius: 10px;
    padding: 16px 20px;
    border: 1px solid #ebeef5;

    .route-line-wrap {
      .route-node {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 6px 0;
        .route-dot {
          width: 12px; height: 12px; border-radius: 50%; flex-shrink: 0; margin-top: 4px;
          &.start-dot { background: #409eff; }
          &.end-dot { background: #f56c6c; }
        }
        .route-node-info {
          .route-node-name { font-size: 15px; font-weight: 600; color: #303133; }
          .route-node-addr { font-size: 12px; color: #909399; margin-top: 2px; }
        }
      }
      .route-connector {
        width: 2px; height: 20px; background: #dcdfe6; margin-left: 5px;
      }
    }

    .trip-meta-row {
      display: flex;
      gap: 20px;
      margin-top: 14px;
      padding-top: 14px;
      border-top: 1px dashed #ebeef5;
      .trip-meta-item {
        flex: 1;
        .trip-meta-label { font-size: 12px; color: #909399; }
        .trip-meta-val { font-size: 14px; font-weight: 600; color: #303133; margin-top: 4px; }
        .price-text { color: #e6a23c; font-size: 18px; }
      }
    }
  }

  /* section 分组标题 */
  .section-label {
    font-size: 14px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 14px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;
  }

  /* 乘客选择列表 */
  .customer-pick-list {
    margin: 0 0 16px;
    padding: 12px 14px;
    background: #fafafa;
    border-radius: 8px;
    border: 1px solid #ebeef5;

    .customer-pick-title { font-size: 12px; color: #909399; margin-bottom: 10px; }

    .customer-pick-item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 10px 12px;
      border-radius: 8px;
      cursor: pointer;
      border: 2px solid transparent;
      transition: all 0.2s;
      & + .customer-pick-item { margin-top: 6px; }
      &:hover { background: #f0f7ff; border-color: #a0cfff; }
      &.selected { background: #ecf5ff; border-color: #409eff; }

      .cp-avatar {
        width: 36px; height: 36px; border-radius: 50%;
        background: linear-gradient(135deg, #409eff, #66b1ff);
        color: #fff; font-size: 16px; font-weight: 700;
        display: flex; align-items: center; justify-content: center;
        flex-shrink: 0;
      }

      .cp-info {
        flex: 1;
        .cp-name { font-size: 14px; font-weight: 600; color: #303133; }
        .cp-phone { font-size: 12px; color: #909399; margin-top: 2px; }
      }

      .cp-check { font-size: 18px; color: #409eff; font-weight: 700; }
    }
  }

  .customer-not-found {
    padding: 10px 14px;
    color: #e6a23c;
    font-size: 13px;
    background: #fdf6ec;
    border-radius: 8px;
    border: 1px solid #faecd8;
    margin-bottom: 16px;
    i { margin-right: 6px; }
  }

  .ofhr-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 24px;
  }

  /* 发单成功 */
  .success-card {
    text-align: center;
    padding: 48px 28px;

    .success-icon { font-size: 68px; color: #67c23a; }
    .success-title { font-size: 24px; font-weight: 700; color: #303133; margin: 16px 0 6px; }
    .success-sub { font-size: 14px; color: #909399; }
    .success-info { margin-top: 16px; }
    .success-trip { margin-top: 12px; font-size: 14px; color: #606266; }
  }
}
</style>
